import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import * as api from '../utils/api';

const Settings = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    // Validation
    if (newPassword.length < 6) {
      setMessage({ type: 'error', text: 'New password must be at least 6 characters' });
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: 'New passwords do not match' });
      return;
    }

    setLoading(true);

    try {
      await api.changePassword(currentPassword, newPassword);
      setMessage({ type: 'success', text: 'Password changed successfully!' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.detail || 'Failed to change password' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container fade-in" data-testid="settings-page">
      <div className="mystical-bg"></div>
      <h1 className="text-center mb-4 glow-text" style={{fontSize: '3rem'}}>
        ⚙️ Settings
      </h1>

      <div className="card" style={{maxWidth: '500px', margin: '0 auto'}}>
        {/* Account Info */}
        <div style={{marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid rgba(139, 92, 246, 0.2)'}}>
          <h2 style={{fontSize: '1.5rem', marginBottom: '1rem', color: '#8b5cf6'}}>
            👤 Account Info
          </h2>
          <p style={{color: '#cbd5e1', marginBottom: '0.5rem'}}>
            <strong>Email:</strong> {user?.email}
          </p>
          <p style={{color: '#cbd5e1', marginBottom: '0.5rem'}}>
            <strong>Username:</strong> {user?.username}
          </p>
          <p style={{color: '#cbd5e1'}}>
            <strong>Subscription:</strong>{' '}
            <span style={{
              padding: '0.25rem 0.75rem',
              borderRadius: '999px',
              fontSize: '0.85rem',
              background: user?.subscription_tier === 'top' 
                ? 'linear-gradient(135deg, #f59e0b, #ef4444)' 
                : user?.subscription_tier === 'basic'
                ? 'linear-gradient(135deg, #8b5cf6, #ec4899)'
                : 'linear-gradient(135deg, #6b7280, #4b5563)',
              color: 'white'
            }}>
              {user?.subscription_tier || 'free'}
            </span>
          </p>
        </div>

        {/* Change Password */}
        <h2 style={{fontSize: '1.5rem', marginBottom: '1rem', color: '#8b5cf6'}}>
          🔐 Change Password
        </h2>

        {message.text && (
          <div className={message.type === 'error' ? 'error-message' : 'success-message'}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleChangePassword}>
          <div className="form-group">
            <label className="form-label">Current Password</label>
            <input
              type="password"
              className="form-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              placeholder="Enter current password"
            />
          </div>

          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Enter new password (min 6 characters)"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirm new password"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{width: '100%'}}
            disabled={loading}
          >
            {loading ? 'Changing...' : '🔒 Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Settings;
